import React from 'react';
import styled from 'styled-components';
import { PaartnerLogo2 } from '../assets';

function Navbar(props) {
    const isStaging = process.env.REACT_APP_ENV === "staging";
    return (
    <Header>
        <HeaderWrapper>
          <Left>
            <Logo
              src={PaartnerLogo2}
              alt="Paartner Logo"
            />
          </Left>
           {isStaging && (
            <>
              <div
                style={{
                  color: "red",
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  zIndex: 9999,
                }}
              >
                🔴 STAGING ENVIRONMENT
              </div>
            </>
          )}
        </HeaderWrapper>
      </Header>
    );
}

export default Navbar;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 24px 16px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Logo = styled.img`
  width: 165px;
  height: 24px;
  position: relative;
`;
